import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "reset-css"
Vue.config.productionTip = false
Vue.use(ElementUI);
function setRemSize() {
  const baseSize = 16; // 基准字体大小
  const scale = window.innerWidth / 1920; // 根据屏幕宽度计算缩放比例
  document.documentElement.style.fontSize = `${baseSize * Math.min(scale, 1)}px`;
}

setRemSize(); // 初始化设置
window.addEventListener('resize', setRemSize); // 监听窗口大小变化事件


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
